// extracted by mini-css-extract-plugin
export default {"svgContainer":"SenatHemicycle_svgContainer__JFEkM","legendContainer":"SenatHemicycle_legendContainer__YgeIh","legendItem":"SenatHemicycle_legendItem__1+ARU"};